import {
  SHIP_PAYMENT_REQUEST,
  SHIP_PAYMENT_SUCCESS,
  SHIP_PAYMENT_FAILED,
  SHIP_PAYMENT_CREATE,
  SHIP_PAYMENT_CREATE_SUCCESS,
  SHIP_PAYMENT_CREATE_FAILED,
  SHIP_PAYMENT_DELETE,
  SHIP_PAYMENT_DELETE_SUCCESS,
  SHIP_PAYMENT_DELETE_FAILED,
  SHIP_PAYMENT_EDIT,
  SHIP_PAYMENT_EDIT_SUCCESS,
  SHIP_PAYMENT_EDIT_FAILED,
  SHIP_PAYMENT_STATE_CHANGE,
} from "../../../_utils/constants/ProductCatalog";


const initialState = {
  valueList: [],
  isLoading: false,
  isSuccess: false,
  isCreated: false,
  isDeleted: false,
  isEdited: false,
  errors: {},
};

const ShipPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHIP_PAYMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        errors: {}
      }
    case SHIP_PAYMENT_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        valueList: decryptedData.result,
        isLoading: false,
        isSuccess: true,
        errors: {}
      }
    case SHIP_PAYMENT_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        errors: action.payload
      }
    case SHIP_PAYMENT_CREATE:
      return {
        ...state,
        isLoading: true,
        isCreated: false,
        errors: {}
      }
    case SHIP_PAYMENT_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isCreated: true,
        errors: {}
      }
    case SHIP_PAYMENT_CREATE_FAILED:
      return {
        ...state,
        isLoading: false,
        isCreated: false,
        errors: action.payload
      }

    case SHIP_PAYMENT_DELETE:
      return {
        ...state,
        isLoading: true,
        isDeleted: false,
        errors: {}
      }
    case SHIP_PAYMENT_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isDeleted: true,
        errors: {}
      }
    case SHIP_PAYMENT_DELETE_FAILED:
      return {
        ...state,
        isLoading: false,
        isDeleted: false,
        errors: action.payload
      }
    case SHIP_PAYMENT_EDIT:
      return {
        ...state,
        isLoading: true,
        isEdited: false,
        errors: {}
      }
    case SHIP_PAYMENT_EDIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isEdited: true,
        errors: {}
      }
    case SHIP_PAYMENT_EDIT_FAILED:
      return {
        ...state,
        isLoading: false,
        isEdited: false,
        errors: action.error
      }

    case SHIP_PAYMENT_STATE_CHANGE:
      return {
        ...state,
        isCreated: false,
        isDeleted: false,
        isEdited: false,
      }
  };
  return state;
};


export default ShipPaymentReducer;